// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__J5\\+lk {
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  display: inline-block;
  height: fit-content;
}
.styles_container__J5\\+lk .styles_wrapper__cyU\\+f {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  height: 100%;
}
.styles_container__J5\\+lk .styles_wrapper__cyU\\+f .styles_prefix__YB4LK,
.styles_container__J5\\+lk .styles_wrapper__cyU\\+f .styles_affix__HMmlW {
  display: flex;
  justify-content: center;
  align-items: center;
}
.styles_container__J5\\+lk .styles_wrapper__cyU\\+f input {
  background-color: transparent;
  width: 100%;
  border: none;
}
.styles_container__J5\\+lk .styles_wrapper__cyU\\+f input:focus-visible {
  outline: 0;
}
.styles_container__J5\\+lk .styles_wrapper__cyU\\+f input::placeholder {
  color: #bababa;
}

.styles_fileContainer__1FD7z {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
}

.styles_absoluteName__xpzP2 {
  max-width: 86%;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  padding: 4px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  color: #fff;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
}

.styles_extraFileStyle__YZZN- {
  width: 100% !important;
}

.styles_downloadIcon__y8F7i {
  position: absolute;
  bottom: 10px;
  left: 10px;
  cursor: pointer;
  padding: 4px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  color: unset !important;
  filter: unset !important;
}

@media screen and (max-width: 800px) {
  .styles_container__J5\\+lk .styles_wrapper__cyU\\+f input {
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 20px;
    /* Gray 4 */
    color: #BDBDBD;
  }
}
@media only screen and (max-width: 650px) {
  .styles_showAbsolute__ocJ0i {
    position: absolute;
    z-index: 1000;
  }
  .styles_hideAbsolute__ZvhFy {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/OnlineChat/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AACJ;AACI;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AACN;AAEI;EACE,6BAAA;EACA,WAAA;EACA,YAAA;AAAN;AAGI;EACE,UAAA;AADN;AAII;EACE,cAAA;AAFN;;AAMA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;AAHF;;AAMA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;AAHF;;AAKA;EACE,sBAAA;AAFF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;EAED,wBAAA;AADD;;AAIA;EAGM;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IAGA,WAAA;IAEA,cAAA;EANN;AACF;AAYA;EACE;IACE,kBAAA;IACA,aAAA;EAVF;EAYA;IAEE,aAAA;EAXF;AACF","sourcesContent":[".container {\n  background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  display: inline-block;\n  height: fit-content;\n\n  .wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 10px;\n    height:100%;\n\n    .prefix,\n    .affix {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    input {\n      background-color: transparent;\n      width: 100%;\n      border: none;\n    }\n\n    input:focus-visible {\n      outline: 0;\n    }\n\n    input::placeholder {\n      color: #bababa;\n    }\n  }\n}\n.fileContainer{\n  width:100%;\n  height:auto;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0,0,0,0.3);\n  // padding-bottom:10px;\n}\n.absoluteName{\n  max-width:86%;\n  position: absolute;\n  top:10px;\n  right:10px;\n  cursor:pointer;\n  padding: 4px;\n  font-size:12px;\n  background: rgba(0,0,0,0.6);\n  border-radius: 4px;\n  color: #fff;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n}\n.extraFileStyle{\n  width:100% !important;\n}\n.downloadIcon{\n  position: absolute;\n  bottom:10px;\n  left:10px;\n  cursor:pointer;\n  padding: 4px;\n  background: rgba(0,0,0,0.6);\n  border-radius: 4px;\n  color: unset !important; \n  -webkit-filter: unset !important; \n filter: unset !important;\n}\n// @media only screen and (max-width: 576px) {\n@media screen and (max-width: 800px) {\n  .container {\n    .wrapper {\n      input {\n        font-style: normal;\n        font-weight: 300;\n        font-size: 12px;\n        line-height: 20px;\n\n\n        /* Gray 4 */\n\n        color: #BDBDBD;\n\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 650px) {\n  .showAbsolute{\n    position:absolute;\n    z-index:1000;\n  }\n  .hideAbsolute{\n    // z-index: unset;\n    display:none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__J5+lk`,
	"wrapper": `styles_wrapper__cyU+f`,
	"prefix": `styles_prefix__YB4LK`,
	"affix": `styles_affix__HMmlW`,
	"fileContainer": `styles_fileContainer__1FD7z`,
	"absoluteName": `styles_absoluteName__xpzP2`,
	"extraFileStyle": `styles_extraFileStyle__YZZN-`,
	"downloadIcon": `styles_downloadIcon__y8F7i`,
	"showAbsolute": `styles_showAbsolute__ocJ0i`,
	"hideAbsolute": `styles_hideAbsolute__ZvhFy`
};
export default ___CSS_LOADER_EXPORT___;
